import { SkeletonBlock, SkeletonText } from "@/components/podkit/loading/Skeleton";
import { ProjectFailedToLoad } from "@/components/projects/ProjectErrors";
import { ProjectSharing } from "@/components/projects/ProjectSharing";
import { useFlagGroupManagementEnabled } from "@/hooks/use-flag";
import { useProject, useProjectState } from "@/queries/project-queries";
import type { FC } from "react";
import { useParams } from "react-router-dom";

export const ProjectSharingPage: FC = () => {
    const { projectId } = useParams();
    const { value: isGroupManagementEnabled } = useFlagGroupManagementEnabled();

    const { data: project, error: getProjectError, isPending: isLoadingProject } = useProject(projectId);
    const {
        data: projectState,
        isLoading: isLoadingProjectStates,
        error: projectStateError,
    } = useProjectState(project?.id);

    const isLoading = isLoadingProject || isLoadingProjectStates || typeof projectState?.shared === "undefined";

    // Don't render sharing controls when group management is enabled
    if (isGroupManagementEnabled) {
        return null;
    }

    let content: React.ReactNode | null = null;
    if (getProjectError || projectStateError || !projectId) {
        content = <ProjectFailedToLoad error={getProjectError || projectStateError} />;
    } else if (isLoading) {
        content = (
            <div className="flex flex-col gap-1">
                <SkeletonText size="lg" ready={false} className="w-[150px]" />
                <SkeletonBlock ready={false} className="h-20 w-56" />
            </div>
        );
    } else {
        content = <>{projectState && <ProjectSharing project={project} state={projectState} />}</>;
    }

    return <div data-testid="project-details-sharing-page">{content}</div>;
};
